<template>
  <div class="w-full">
    <div v-if="data.extensions.length > 1">
      <button
        v-if="compress_sidebar"
        v-tippy="{ arrow: true, theme: 'green', boundary: 'viewport' }"
        :content="data.extension_owner"
        @click="handleDropdown"
        :class="[
          dropdownIsActive
            ? 'border-ontick-carbon-500 border-l-4 pl-5 dark:text-gray-100'
            : '  text-gray-100 hover:text-white',
          compress_sidebar
            ? 'space-x-1 pl-3'
            : ' group text-made justify-between  py-2 pl-6 pr-5 font-normal leading-6 transition duration-150 ease-in-out',
          'bg-ontick-graphite-500 flex w-full items-center',
        ]"
      >
        <div class="flex items-center space-x-4">
          <img
            :src="data.extension_logo"
            class="text-ontick-blue-500 demo:text-gray-500 h-5 w-5"
          />
          <p v-show="!compress_sidebar">{{ data.extension_owner }}</p>
        </div>
        <div
          class="transform-gpu transition-all ease-in-out"
          :class="dropdownIsActive ? 'rotate-90' : '-rotate-90'"
        >
          <i v-html="$icons.chevron_left"></i>
        </div>
      </button>
      <button
        v-else
        @click="handleDropdown"
        :class="[
          dropdownIsActive
            ? 'border-ontick-carbon-500 border-l-4 pl-5 dark:text-gray-100'
            : '  text-gray-100 hover:text-white',
          compress_sidebar
            ? 'space-x-1 pl-3'
            : ' group text-made justify-between  py-2 pl-6 pr-5 font-normal leading-6 transition duration-150 ease-in-out',
          'bg-ontick-graphite-500 flex w-full items-center',
        ]"
      >
        <div class="flex items-center space-x-4">
          <img
            :src="data.extension_logo"
            class="text-ontick-blue-500 demo:text-gray-500 h-5 w-5"
          />
          <p v-show="!compress_sidebar">{{ data.extension_owner }}</p>
        </div>
        <div
          class="transform-gpu transition-all ease-in-out"
          :class="dropdownIsActive ? 'rotate-90' : '-rotate-90'"
        >
          <i v-html="$icons.chevron_left"></i>
        </div>
      </button>
      <transition
        name="expand-down"
        @before-enter="beforeEnterAndLeave"
        @enter="beforeLeaveAndEnter"
        @before-leave="beforeLeaveAndEnter"
        @leave="beforeEnterAndLeave"
      >
        <ul v-if="dropdownIsActive" class="overflow-hidden">
          <li
            v-for="extension in data.extensions"
            :key="extension.extension_id"
          >
            <router-link
              v-if="compress_sidebar"
              v-tippy="{ arrow: true, theme: 'green', boundary: 'viewport' }"
              :content="extension.extension_name"
              :to="{
                name: 'Estratégias de parceiro',
                params: {
                  partner_name: data.extension_path,
                  extension_id: extension.extension_id,
                },
              }"
              :class="[
                $route.params.extension_id === extension.extension_id
                  ? 'border-ontick-blue-800 bg-ontick-carbon-500 demo:border-gray-400 dark:text-gray-100'
                  : ' border-ontick-carbon-500 bg-ontick-graphite-500 text-gray-100 hover:text-white',
                'group text-made flex w-full items-center border-l-4 px-2 py-2 font-normal leading-6 transition duration-150 ease-in-out',
              ]"
            >
              <p v-show="!compress_sidebar" class="whitespace-nowrap pl-3">
                {{ extension.extension_name }}
              </p>
            </router-link>
            <router-link
              v-else
              :to="{
                name: 'Estratégias de parceiro',
                params: {
                  partner_name: data.extension_path,
                  extension_id: extension.extension_id,
                },
              }"
              :class="[
                $route.params.extension_id === extension.extension_id
                  ? 'border-ontick-blue-800 bg-ontick-carbon-500 demo:border-gray-400 dark:text-gray-100'
                  : ' border-ontick-carbon-500 bg-ontick-graphite-500 text-gray-100 hover:text-white',
                'group text-made flex w-full items-center border-l-4 px-2 py-2 font-normal leading-6 transition duration-150 ease-in-out',
              ]"
            >
              <p v-show="!compress_sidebar" class="whitespace-nowrap pl-3">
                {{ extension.extension_name }}
              </p>
            </router-link>
          </li>
        </ul>
      </transition>
    </div>
    <template v-else>
      <router-link
        v-if="compress_sidebar"
        v-tippy="{ arrow: true, theme: 'green', boundary: 'viewport' }"
        :content="data.extension_owner"
        :to="{
          name: 'Estratégias de parceiro',
          params: {
            partner_name: data.extension_path,
            extension_id: data.extensions[0].extension_id,
          },
        }"
        :class="[
          $route.params.extension_id == data.extensions[0].extension_id
            ? 'border-ontick-blue-800 bg-ontick-carbon-500 demo:border-gray-400 border-l-4 dark:text-gray-100'
            : 'bg-ontick-graphite-500 ml-1 text-gray-100 hover:text-white',
          'group text-made flex w-full items-center justify-between py-2 px-5 font-normal leading-6 transition duration-150 ease-in-out',
        ]"
      >
        <div class="flex items-center">
          <img
            :src="data.extension_logo"
            class="text-ontick-blue-500 demo:text-gray-500 mr-4 h-5 w-5"
          />
          <p v-show="!compress_sidebar">{{ data.extension_owner }}</p>
        </div>
      </router-link>
      <router-link
        v-else
        :to="{
          name: 'Estratégias de parceiro',
          params: {
            partner_name: data.extension_path,
            extension_id: data.extensions[0].extension_id,
          },
        }"
        :class="[
          $route.params.extension_id == data.extensions[0].extension_id
            ? 'border-ontick-blue-800 bg-ontick-carbon-500 demo:border-gray-400 border-l-4 dark:text-gray-100'
            : 'bg-ontick-graphite-500 ml-1 text-gray-100 hover:text-white',
          'group text-made flex w-full items-center justify-between py-2 px-5 font-normal leading-6 transition duration-150 ease-in-out',
        ]"
      >
        <div class="flex items-center">
          <img
            :src="data.extension_logo"
            class="text-ontick-blue-500 demo:text-gray-500 mr-4 h-5 w-5"
          />
          <p v-show="!compress_sidebar">{{ data.extension_owner }}</p>
        </div>
      </router-link>
    </template>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";
export default {
  directives: {
    ClickOutside,
  },

  props: {
    data: {
      type: Object,
    },
    compress_sidebar: {
      type: Boolean,
    },
  },

  data() {
    return {
      dropdownIsActive: false,
      isCompressed: this.compress_sidebar,
    };
  },

  methods: {
    handleDropdown() {
      this.dropdownIsActive = !this.dropdownIsActive;
      if (this.dropdownIsActive) {
        this.$emit("expand");
      }
    },
    close() {
      this.dropdownIsActive = false;
    },
    beforeEnterAndLeave: function (el) {
      el.style.height = "0";
    },
    beforeLeaveAndEnter: function (el) {
      el.style.height = el.scrollHeight + "px";
    },
  },

  watch: {
    "$route.params.partner_name": {
      handler(val) {
        if (val !== this.data.extension_path) {
          this.dropdownIsActive = false;
        }
      },
    },
    compress_sidebar: {
      handler(val) {
        if (val) this.dropdownIsActive = false;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.expand-down {
  &-enter-active,
  &-leave-active {
    @apply transition-all ease-in-out;
  }
}
</style>
